import { useState } from 'react';

import Faq from '#client/components/Faq';

import BankingFeature from './components/BankingFeature';
import FinishApplicationBanner from './components/FinishApplicationBanner';
import Footer from './components/Footer';
import PageWrapper from './components/PageWrapper';
import ProductGroup from './components/ProductGroup';
import TermsTriptych from './components/TermsTriptych';

export default function Experimentation() {
  const [showBanner, setShowBanner] = useState(false);

  return (
    <>
      <ProductGroup callback={setShowBanner} />
      <TermsTriptych />
      <BankingFeature />
      <PageWrapper>
        <Faq />
      </PageWrapper>
      <Footer />
      {showBanner && <FinishApplicationBanner />}
    </>
  );
}
